<div class="changes-div">
  <ul class="timeline">
    <li *ngFor="let c of changes" class="change">
      <div class="card">
        <div class="top">
          <div class="date">
            {{ dateAsString(c.date) }}
          </div>
          <div class="user" *ngIf="hasUser(c)">
            {{ c.username }}
          </div>
        </div>
        <div class="bottom">
          <div *ngFor="let item of c.changes | keyvalue" style="padding-bottom: 10px">
            <ng-container [ngSwitch]="item.value?.type">
              <ng-container *ngSwitchCase="'EMAIL_SENT'">
                Email Sent{{ item.value?.recipientType ? ' to ' + item.value?.recipientType : '' }}:
                <br />
                - Template: <span class="code">{{ item.value.template }}</span
                ><br />
                - Sendgrid message ID:
                <span class="code"
                  ><a
                    [routerLink]="['/', 'inspection', 'emailEvent', 'list']"
                    [queryParams]="{ sg_message_id: item.value.messageId }"
                    >{{ item.value.messageId || 'none' }}</a
                  ></span
                >
              </ng-container>

              <ng-container *ngSwitchCase="'Rec_EMAIL_SENT'">
                Rec Letter Email Sent
                <br />
                To: <span class="code cursor-">{{ item.value.to }}</span>
                <br />
                <span *ngIf="item.value?.cc">
                  Cc: <span class="code cursor-">{{ item.value.cc }}</span></span
                ><br />
                <span class="code cursor-pointer" (click)="previewEmail(item.value.id)">Preview Email</span>
              </ng-container>

              <ng-container *ngSwitchDefault>
                - Changed field <span class="code">{{ item.key }}</span> from
                <span class="code">{{ item.value.before }}</span> to <span class="code">{{ item.value.after }}</span>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
